module.exports = __webpack_public_path__ + "img/icon_video_interativo_e_personalizado.8e133ae4.svg";